import {Injectable} from '@angular/core';
import {Headers, Http, Response} from '@angular/http';
import 'rxjs/add/operator/toPromise';
import {webapi} from '../../shared/my-constants';

@Injectable()
export class MstCashCounterService {
  mstCashCounter: any;
  private headers = new Headers({'Content-Type': 'application/json'});
  private ccListByUnitId = webapi + 'mst_cash_counter/cclistbyunitid/?';
  private ListRecord = webapi + 'mst_cash_counter/list/?';
  private AddRecord = webapi + 'mst_cash_counter/create';
  private EditRecord = webapi + 'mst_cash_counter/update';
  private GetRecord = webapi + 'mst_cash_counter/byid/';
  private DeleteRecord = webapi + 'mst_cash_counter/delete/';
  private ReActiveRecord = webapi + 'mst_cash_counter/reActive/';
  private DeListRecord = webapi + 'mst_cash_counter/deactivated_list/?';

  constructor(
    private http: Http
  ) {
  }
    getAllDeactivatedRecordService(currentPage: any, size: any, qString: any, sort: any, col: any): Promise<any> {
        // console.log(this.ListRecord + 'page=' + currentPage + '&size=' + size + '&qString=' + qString + '&sort=' + sort + '&col=' + col);
        return this.http.get(this.DeListRecord + 'page=' + currentPage + '&size=' + size + '&qString=' + qString + '&sort=' + sort + '&col=' + col)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }
    reActiveRecordService(id: any) {
        return this.http.put(this.ReActiveRecord + id, {headers: this.headers})
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

  getAllRecordService(currentPage: any, size: any, qString: any, sort: any, col: any): Promise<any> {
    return this.http.get(this.ListRecord + 'page=' + currentPage + '&size=' + size + '&qString=' + qString + '&sort=' + sort + '&col=' + col)
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  getCCListByUnitId(unitId: any): Promise<any> {
    return this.http.get(this.ccListByUnitId + 'unitId=' + unitId)
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  addRecordService(model: any) {
    return this.http.post(this.AddRecord, JSON.stringify(model), {headers: this.headers})
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  editRecordService(model: any) {
    return this.http.put(this.EditRecord, JSON.stringify(model), {headers: this.headers})
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  deleteRecordService(id: any) {
    return this.http.put(this.DeleteRecord + id, {headers: this.headers})
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  getRecordService(id: any) {
    return this.http.get(this.GetRecord + id)
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  private handleError(error: Response | any) {
    return Promise.reject(error.message || error);
  }
}




// WEBPACK FOOTER //
// D:/CODE_REPOSITORIES/HIMS/HIMS_FRONTEND/src/app/configuration/mst-cash-counter/mst-cash-counter.service.ts